import React, { useEffect } from "react";
import { Typography, Box, Grid, useMediaQuery } from "@mui/material";
import { connect } from "react-redux";
import { homeActions } from "actions";
import StaticHtmlTemplate from "components/StaticHtmlTemplate";
import { Helmet } from "react-helmet";

const PrivacyPolicy = (props) => {
  const { getContentType, contentInfo, organizationInfo } = props;
  const [termsData, setTermsData] = React.useState({});
  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    getContentType("privacy_policy");
    props.setValue(5);
  }, []);

  useEffect(() => {
    if (contentInfo && contentInfo.privacy_policy) {
      setTermsData(contentInfo.privacy_policy);
    }
  }, [contentInfo]);

  return (
    <StaticHtmlTemplate pageTitle="PRIVACY POLICY">
      <Helmet>
        <title>
          Privacy Policy |{" "}
          {organizationInfo?.app?.appCode === "CVD"
            ? "Cuverd® Partner"
            : "Cuverd®"}
        </title>
        <meta
          name="description"
          content="The Privacy Policy Agreement for the Cuverd prescription medication savings and discount mobile app and website."
        />
        <meta property="og:title" content="Privacy Policy | Cuverd®" />
        <meta
          property="og:description"
          content="The Privacy Policy Agreement for the Cuverd prescription medication savings and discount mobile app and website."
        />
        <meta
          property="og:image"
          content="assets/images/cuverd-logo-header.png"
        />
        <link
          rel="alternate"
          href="https://www.cuverd.com/privacy-policy"
          hrefLang="en-us"
        />
        <link rel="canonical" href="https://www.cuverd.com/privacy-policy" />
      </Helmet>
      <Grid container sx={{ margin: "auto" }} justifyContent="center">
        <Grid item xs={12} sm={10}>
          <Box>
            <Typography variant="h1LatoBold">
              {termsData && termsData?.contentTitle}
            </Typography>
          </Box>
          <Box sx={{ marginTop: "12px" }}>
            <Typography variant="h4LatoRegular" sx={{ color: "#607277" }}>
              Last Modified: {termsData && termsData?.lastModifiedDate}
            </Typography>
          </Box>
          <Box
            sx={{
              paddingTop: "1rem",
              paddingBottom: "3rem",
              marginBottom: "32px",
            }}
          >
            {termsData && termsData.content && (
              <iframe
                src={`${termsData?.content}?channel=${
                  matchesMinWidth ? "mobileweb" : "web"
                }`}
                frameBorder="0"
                border="0"
                cellSpacing="0"
                style={{ height: "800px", borderStyle: "none", width: "100%" }}
                title="Details"
                scrolling="yes"
              ></iframe>
            )}
          </Box>
        </Grid>
      </Grid>
    </StaticHtmlTemplate>
  );
};

const mapStateToProps = (state) => {
  return {
    contentInfo: state.contentType.data,
    organizationInfo: state.organizationInfo.data,
  };
};

const mapDispatchToProps = {
  getContentType: (type) => homeActions.getContentType(type),
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy);
